import { bootstrapApplication } from '@angular/platform-browser';
import { ipensiiAppConfig } from './app/ipensii-app.config';
import { IpensiiAppComponent } from './app/ipensii-app.component';
import { enableProdMode } from '@angular/core';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(IpensiiAppComponent, ipensiiAppConfig).catch((err) => console.error(err));
